export const OFLC_REJECT_INVITATION = 'OFLC_REJECT_INVITATION';
export const OFLC_REJECT_INVITATION_SUCCESS = 'OFLC_REJECT_INVITATION_SUCCESS';
export const OFLC_REJECT_INVITATION_FAILURE = 'OFLC_REJECT_INVITATION_FAILURE';

export function rejectInvitation(payload) {
	console.log('Action Reject', payload);
	return {
		type: OFLC_REJECT_INVITATION,
		payload
	};
}

export function rejectInvitationSuccess(payload) {
	return {
		type: OFLC_REJECT_INVITATION_SUCCESS,
		payload: payload
	};
}

export function rejectInvitationFail(payload) {
	return {
		type: OFLC_REJECT_INVITATION_FAILURE,
		payload: payload
	};
}
